<ng-container *ngSubscribe="todos as todos">
  <h2>{{ service }} todo list...</h2>
  <components-list flow="column" density="high">
    @for (todo of todos; track todo) {
      <todo [all]="todos" [todo]="todo" class="d-flex flex-nowrap align-items-center"></todo>
    }
  </components-list>
</ng-container>
